import placeholderDog from './compressed/placeholder-dog.webp';
import placeholderShelter from './compressed/placeholder-shelter.webp';
import placeholderUser from './compressed/placeholder-user.webp';
import placeholderVideo from './compressed/placeholder-video.webp';
import placeholder from './compressed/placeholder.webp';

export { placeholder, placeholderDog, placeholderUser, placeholderVideo, placeholderShelter };
